import { Component, OnInit, Input, AfterViewInit, } from '@angular/core';
import moment from 'moment';
import { CoreEventField } from 'app/_models';

declare var $: any;

@Component({
  selector: 'app-core-event-field',
  templateUrl: './core-event-field.component.html'
})
export class CoreEventFieldComponent implements OnInit, AfterViewInit {
  @Input() field: CoreEventField;
  @Input() lists: any;
  @Input() eventValues: any;
  @Input() isVisibleSpace: boolean;

  // 1–9 dropdown options for the Duration field (kept as strings so the value
  // round-trips with the string column without a type mismatch).
  durationOptions: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9'];

  constructor() { }

  ngOnInit() {
    // Duration defaults to 1 when nothing is set yet (e.g. creating an event).
    if (this.field.type === 'duration' && this.eventValues
      && (this.eventValues[this.field.id] == null || this.eventValues[this.field.id] === '')) {
      this.eventValues[this.field.id] = '1';
    }
  }
  ngAfterViewInit() {
    if (this.field.is_half) {
      $(".half-field").parents('.field-item').addClass('col-3');
    } else {
      $(".full-field").parents('.field-item').addClass('col-6');
    }
  }

  getDateValue(): Date | null {
    const val = this.eventValues?.[this.field.id];
    if (val == null || val === '') {
      return null;
    }
    if (val instanceof Date) {
      return val;
    }
    const strict = moment(val, 'YYYY-MM-DD', true);
    if (strict.isValid()) {
      return strict.toDate();
    }
    const parsed = moment(val);
    return parsed.isValid() ? parsed.toDate() : null;
  }

  onDateChange(date: Date | null): void {
    if (!this.eventValues) {
      return;
    }
    this.eventValues[this.field.id] = date ? moment(date).format('YYYY-MM-DD') : null;
  }

  // Amount fields accept pasted values like "$1,234.50": strip the currency
  // symbol/commas and keep a plain number (digits + a single decimal point),
  // capped at 10 characters.
  onAmountChange(value: string): void {
    if (!this.eventValues) {
      return;
    }
    this.eventValues[this.field.id] = this.sanitizeAmount(value);
  }

  private sanitizeAmount(value: string): string {
    if (value == null) {
      return value;
    }
    let cleaned = String(value).replace(/[^0-9.]/g, '');
    const firstDot = cleaned.indexOf('.');
    if (firstDot !== -1) {
      cleaned = cleaned.slice(0, firstDot + 1) + cleaned.slice(firstDot + 1).replace(/\./g, '');
    }
    return cleaned.slice(0, 10);
  }

}